/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /payouts/export/sepa
 */
export interface SepaRequestBuilder extends BaseRequestBuilder<SepaRequestBuilder> {
    /**
     * GetPayoutsSepaExport
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<SepaRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * GetPayoutsSepaExport
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SepaRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetPayoutsSepaExport
 */
export interface SepaRequestBuilderGetQueryParameters {
    payoutId?: Guid;
}
/**
 * Uri template for the request builder.
 */
export const SepaRequestBuilderUriTemplate = "{+baseurl}/payouts/export/sepa?PayoutId={PayoutId}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const SepaRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "payoutId": "PayoutId",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SepaRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SepaRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        queryParametersMapper: SepaRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
